import Button from '@atlaskit/button';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle
} from '@atlaskit/modal-dialog';
import { isVersion } from 'src/utils/version';

interface LoseChangeModalProps {
  onClose: (accept: boolean) => void;
}

export const LoseChangesModal = ({ onClose }: LoseChangeModalProps) => {
  return (
    <Modal onClose={() => onClose(false)} width="small">
      <ModalHeader>
        <ModalTitle>{'Switch templates?'}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <p>
          {'Trying a different template will erase the content on your page.'}
          <br />
          <br />
          {isVersion(2)
            ? 'To save pages, sign up for a free Confluence site.'
            : 'To save pages and share them with your team, sign up for a free Confluence site.'}
        </p>
      </ModalBody>
      <ModalFooter>
        <Button appearance="subtle" onClick={() => onClose(false)}>
          {'Keep editing'}
        </Button>
        <Button appearance="primary" onClick={() => onClose(true)} autoFocus>
          {'Switch templates'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
